import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { ScaledTextButton } from '../../../../components/scaledTextButton';
import { ScaledTextButtonCheckboxIcon } from '../../../../components/scaledTextButtonCheckboxIcon';
import { setIsAutoChecking } from '../../../../redux/actions/pokerActions';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { getOnOffBooleanLabel } from '../../../../utils/utils';
export const DomAutoCheckButton = ({ bounds }) => {
    const dispatch = useAppDispatch();
    const isAutoChecking = useAppSelector((state) => !!state.poker.autoBetProperties?.isAutoChecking);
    const onClickAutoCheck = useCallback(() => {
        dispatch(setIsAutoChecking(!isAutoChecking));
    }, [dispatch, isAutoChecking]);
    const { x, y, w, h } = bounds;
    return (_jsx(ScaledTextButton, { onClick: onClickAutoCheck, label: 'CHECK', theme: isAutoChecking ? 'auto-bet-on' : 'auto-bet-off', x: x, y: y, w: w, h: h, startIcon: _jsx(ScaledTextButtonCheckboxIcon, { isChecked: isAutoChecking }), testId: 'auto-check', ariaLabelOverride: `Auto-check is ${getOnOffBooleanLabel(isAutoChecking)}` }));
};
